var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edit-icon-text") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-May-2025",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "09-BOOKINGv2-3---Selected",
    transform: "translate(-74, -2373)",
    fill: "#010421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(10, 313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy-5",
    transform: "translate(0, 250)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotel-details-card-copy",
    transform: "translate(0, 978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pen-to-square-light-copy",
    transform: "translate(64, 832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7847092,3.2628161 L36.7371839,4.21529076 C37.7211453,5.19925219 37.7211453,6.79720555 36.7371839,7.78116698 L34.6354423,9.88290859 L30.1170914,5.36455771 L32.218833,3.2628161 C33.2027945,2.27885467 34.8007478,2.27885467 35.7847092,3.2628161 Z M14.8774968,20.6041523 L28.3380891,7.14355997 L32.85644,11.6619109 L19.3958477,25.1225032 C19.0652366,25.4531142 18.6401653,25.689265 18.1836072,25.7994687 L13.0197776,26.9880941 L14.208403,21.8163928 C14.310735,21.3598347 14.5468858,20.9347634 14.8853685,20.6041523 L14.8774968,20.6041523 Z M30.4398308,1.47594214 L13.0984945,18.8251501 C12.4294008,19.4942438 11.964971,20.3365148 11.7524353,21.2575027 L10.1072518,28.3892551 C10.0127915,28.8143265 10.1387386,29.2551412 10.4457345,29.5621372 C10.7527305,29.8691331 11.1935452,29.9950802 11.6186166,29.9006199 L18.750369,28.2554364 C19.6713569,28.0429007 20.5136279,27.5784709 21.1827216,26.9093772 L38.5240579,9.56016924 C40.4919807,7.59224638 40.4919807,4.40421135 38.5240579,2.4362885 L37.5715832,1.47594214 C35.6036603,-0.491980714 32.4156253,-0.491980714 30.4477025,1.47594214 L30.4398308,1.47594214 Z M6.29735314,4.73482239 C2.81806553,4.73482239 0,7.55288793 0,11.0321755 L0,33.7026469 C0,37.1819345 2.81806553,40 6.29735314,40 L28.9678245,40 C32.4471121,40 35.2651776,37.1819345 35.2651776,33.7026469 L35.2651776,23.6268818 C35.2651776,22.934173 34.6984158,22.3674112 34.005707,22.3674112 C33.3129981,22.3674112 32.7462363,22.934173 32.7462363,23.6268818 L32.7462363,33.7026469 C32.7462363,35.7886451 31.0538227,37.4810587 28.9678245,37.4810587 L6.29735314,37.4810587 C4.21135491,37.4810587 2.51894126,35.7886451 2.51894126,33.7026469 L2.51894126,11.0321755 C2.51894126,8.94617731 4.21135491,7.25376365 6.29735314,7.25376365 L16.3731182,7.25376365 C17.065827,7.25376365 17.6325888,6.68700187 17.6325888,5.99429302 C17.6325888,5.30158418 17.065827,4.73482239 16.3731182,4.73482239 L6.29735314,4.73482239 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.667d317f8709ec6f805e393726f38ca2.svg";
export { ForwardRef as ReactComponent };